import { EventContainer } from '../../../../../core/components/atoms/EventContainer';
import { EventListHeader } from '../../../../../core/components/atoms/EventListHeader';
import { EventListLoading } from '../../../../../core/components/atoms/EventListLoading';
import { Typography } from '../../../../../core/components/molecules/Typography';
import { EventDetails } from '../../../../../core/components/organism/EventDetails';
import { EventDetailsModal } from '../../../../../core/components/organism/EventDetailsModal';
import { WeekCalendar } from '../../../../../core/components/organism/WeekCalendar';
import { useTimelineTab } from '../../../hooks/AprovaLive/useTimelineTab';
import { AprovaLiveDetailFooter } from '../AprovaLiveDetailFooter';
import { AprovaLiveList } from '../AprovaLivelist';

function TimelineTab({ origin }: { origin: 'aprova-live' | 'challenge' }) {
  const {
    onSelectDate,
    selectedDate,
    filteredLiveClasses,
    isLoadingLives,
    onSelectItem,
    selectedEvent,

    isModalEventDetailsOpen,
    setIsModalEventDetailsOpen,
    itsAprovaLiveRecordAvailable,
    isLoadingRegister,
    handleOpenLiveClass,
  } = useTimelineTab(origin);

  const isOnboarding = selectedEvent?.type === 'onboarding';

  const eventDetailsProps = selectedEvent
    ? {
        event: {
          startDate: new Date(selectedEvent.startDate),
          endDate: new Date(selectedEvent.endDate),
          teacherName: selectedEvent.teacher,
          title: selectedEvent.title,
          description: selectedEvent.description,
          thumbnailUrl: selectedEvent.thumbnail,
          tags: [
            isOnboarding ? 'Onboarding' : 'AprovaLive',
            selectedEvent.area?.title,
          ].filter(Boolean) as string[],
        },
        footer: (
          <AprovaLiveDetailFooter
            startDate={new Date(selectedEvent.startDate)}
            endDate={new Date(selectedEvent.endDate)}
            eventId={selectedEvent._id}
            onOpenClass={handleOpenLiveClass}
            hasRecordAvailable={itsAprovaLiveRecordAvailable(selectedEvent)}
            isLoading={isLoadingRegister}
          />
        ),
      }
    : {};

  return (
    <section className='flex flex-col gap-xl'>
      <WeekCalendar onSelectDate={onSelectDate} />

      <div className='grid grid-cols-1 gap-xl lg:grid-cols-2'>
        <EventContainer className='!flex'>
          <EventListHeader type='date' date={selectedDate} />
          {isLoadingLives ? (
            <EventListLoading itemsCount={3} />
          ) : (
            <AprovaLiveList
              items={filteredLiveClasses}
              onClick={onSelectItem}
            />
          )}
        </EventContainer>

        <EventContainer className='lg:flex'>
          <EventListHeader type='title' title='Detalhes do evento' />

          {selectedEvent ? (
            <EventDetails {...eventDetailsProps} />
          ) : (
            <div className='flex h-full items-center justify-center'>
              <Typography variant='italic' className='mt-7'>
                Selecione um evento da agenda para ver os detalhes
              </Typography>
            </div>
          )}
        </EventContainer>
      </div>

      <EventDetailsModal
        {...eventDetailsProps}
        isOpen={isModalEventDetailsOpen}
        onClose={() => {
          setIsModalEventDetailsOpen(false);
        }}
      />
    </section>
  );
}

export { TimelineTab };
